import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import spartaStyleUtility from "global/sparta-style-utility";
import Module from "global/sparta-module-utility";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/community/connect-with-us-module/2.1.0/css/connect-with-us-module.scss.css";

const scope = {};
class connectWithUsModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'connect-with-us-module', precompiled: {"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"skin-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1), depth0))
    + "\">";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "      <div class=\"block-container "
    + alias2(alias1((depth0 != null ? depth0.displayClass : depth0), depth0))
    + "\">\n        <div class=\"block\">\n          <div class=\"block-inner\" id=\""
    + alias2(alias1((depth0 != null ? depth0.buttonID : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.chat : depth0)) != null ? stack1.sticky : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n            <div class=\"content-container\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.chat : depth0)) != null ? stack1["static"] : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            >\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.title : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.content : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n          </div>\n        </div>\n      </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"icon\">\n              <img height=\"100%\" width=\"100%\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.icon : depth0), depth0))
    + "\" alt=\"\"/>\n            </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "              <div class=\"stickyChat\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.chat : depth0)) != null ? stack1.sticky : stack1), depth0))
    + "\"></div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                chat-container\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.chat : depth0)) != null ? stack1["static"] : stack1), depth0));
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "              <div class=\"title\">\n                <h3>"
    + ((stack1 = container.lambda((depth0 != null ? depth0.title : depth0), depth0)) != null ? stack1 : "")
    + "</h3>\n              </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "              <div class=\"content "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.contentClass : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.content : depth0),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "              </div>\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                  <p class=\""
    + container.escapeExpression(alias1((depth0 != null ? depth0["class"] : depth0), depth0))
    + "\">\n                    "
    + ((stack1 = alias1((depth0 != null ? depth0.text : depth0), depth0)) != null ? stack1 : "")
    + "\n                  </p>\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? depth0.children : depth0)) != null ? stack1.socialModule : stack1), depth0)) != null ? stack1 : "")
    + "\n";
},"17":function(container,depth0,helpers,partials,data) {
    return "</div>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : {};

  return "\n\n<style type=\"text/css\">\n\n  .accordion-trigger:before {\n    position: absolute;\n    content: \" \";\n    width: 15px;\n    height: 10px;\n    top: 5px;\n    left: -5px;\n    background-image: url('"
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.data1 : depth0)) != null ? stack1.LINKS : stack1)) != null ? stack1.accordionLink : stack1)) != null ? stack1.icon : stack1), depth0)) != null ? stack1 : "")
    + "');\n    background-repeat: no-repeat;\n    background-size: 12px 12px;\n    transform: rotate(-90deg);\n    transition: transform 500ms;\n    transform-origin: 7px 5px;\n  }\n\n\n</style>\n\n\n\n"
    + ((stack1 = helpers["if"].call(alias2,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div class=\"row large-collapse\" id=\"connect-container\">\n  <div class=\"columns small-12 large-10 large-offset-1 end\">\n    <h2 id=\"heading\">"
    + container.escapeExpression(alias1(((stack1 = (depth0 != null ? depth0.data1 : depth0)) != null ? stack1.heading : stack1), depth0))
    + "</h2>\n    <div class=\"blocks-container\">\n"
    + ((stack1 = helpers.each.call(alias2,((stack1 = (depth0 != null ? depth0.data1 : depth0)) != null ? stack1.blocks : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n  </div>\n</div>\n<div class=\"row\">\n  <div class=\"columns small-12\">\n    <div class=\"social-container\">\n"
    + ((stack1 = helpers["if"].call(alias2,((stack1 = (depth0 != null ? depth0.children : depth0)) != null ? stack1.socialModule : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n  </div>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias2,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new connectWithUsModuleTemplates();
